import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/authContext';
import { BrowserRouter } from 'react-router-dom';
import ReactGA from 'react-ga4';

let currentTrackingId = process.env.REACT_APP_GA_TRACKING_ID;

if (currentTrackingId) {
  ReactGA.initialize(currentTrackingId);
  // console.log(`Google Analytics initialized with ID: ${currentTrackingId}`);
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
} else {
  console.error("Google Analytics Tracking ID is missing!");
}

let clarityProjectId = process.env.REACT_APP_CLARITY_PROJECT_ID || "y690nqwz7y";

if (clarityProjectId) {
  (function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", clarityProjectId);
  // console.log(`Microsoft Clarity initialized with ID: ${clarityProjectId}`);
} else {
  console.error("Microsoft Clarity Project ID is missing!");
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
